import type { Language } from '@eformulieren/engine'
import type { ReactNode } from 'react'

/**
 * Wachten tot het document er is (valkuil 6 uit bijlage C.4).
 *
 * **Nooit een leeg formulier tonen vóór de eerste synchronisatie.** Zonder
 * wachtscherm ziet de invuller lege velden en denkt hij dat zijn werk weg is; dat is
 * de melding die de POC opleverde en die veel erger overkomt dan wachten. In M2 is
 * "er" een lokaal document dat er meteen is, vanaf M3 de eerste synchronisatie met
 * de pod. De vorm van het wachten is nu al goed, zodat er in M3 alleen een andere
 * voorwaarde in gaat.
 */
export interface WaitScreenProps {
  readonly taal: Language
  readonly gereed: boolean
  readonly children: ReactNode
}

export function WaitScreen({ taal: language, gereed: ready, children }: WaitScreenProps): ReactNode {
  if (ready) return children
  return (
    <div className="ef-wachtscherm" role="status" aria-live="polite">
      {language === 'nl'
        ? 'Het formulier wordt geladen. Uw eerdere antwoorden komen mee.'
        : 'Loading the form. Your earlier answers will be included.'}
    </div>
  )
}
